import React, { useState, useEffect } from "react";
import Select from "react-select";
import {Search} from 'lucide-react';
import classes from ".././ManageUser/ProvincalUser.module.css"
import plus from "../../../Assets/plus.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { Spinner, Badge, Button, Modal, OverlayTrigger, Tooltip, Form, Row, Col, Container, Table } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import axios from 'axios';
import Swal from 'sweetalert2';
import HeaderNav from "../../FixedAssetReport/AdminNav/FixedAdminNav";
import RotatingLogo from '../../../Assets/rotating-logo.png';
import {  FaPlus } from "react-icons/fa";  
import download from "../../../Assets/download1.svg"
import { BASE_URL, TOKEN, BASE_URL1 } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";




const FixedAssetAdminUser = () => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [searchTerm,setSearchTerm] = useState("");
    const [show, setShow] = useState(false);
    const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [show1, setShow1] = useState(false);
  const [uploadShow, setUploadShow] = useState(false);
  const [file, setFile] = useState(null);
  const [bearer, setBearer] = useState('');
  const [uploadLoading, setUploadLoading] = useState(false);
  const [bankName, setBankName] = useState('');
  const [bankName1, setBankName1] = useState('');
  const [accName, setAccName] = useState('');
  const [accName1, setAccName1] = useState('');
  const [accNo, setAccNo] = useState('');
  const [accNo1, setAccNo1] = useState('');
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState();
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState();
  const [address, setAddress] = useState([]);
  const [address1, setAddress1] = useState();
  const [phone, setPhone] = useState();
  const [phoneNo, setPhoneNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [totalEntries, setTotalEntries] = useState("");
  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const navigate = useNavigate();
  const [searchedResult, setSearchedResult] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [benLoading, setBenLoading] = useState(false);
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [role, setRole] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [createLoading, setCreateLoading] = useState(false);
  // Replace const [continents, setContinents] = useState([]);
const [continentOptions, setContinentOptions] = useState([]);

  // const [selectType, setSelectType] = useState(userData?.type || "");
  // const [selectedProvince, setSelectedProvince] = useState(userData?.province_id || "");
  const [selectedProvince, setSelectedProvince] = useState();
  const [selectType, setSelectType] = useState("");
  const [userType, setUserType] = useState([]);
  const [continents, setContinents] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [tableData5, setTableData5] = useState([]);
  const [contLoading, setContLoading] = useState(false);
  const [subContloading, setSubContLoading] = useState(false);
  const [subRegloading, setSubRegLoading] = useState(false);
  const [admin, setAdmin] = useState("");
  const [selectedContinent, setSelectedContinent] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [totalPages, setTotalPages] = useState(1);
const [totalEntries, setTotalEntries] = useState("");  

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const value3 = await localStorage.getItem('admin');

      if (value !== null) {

        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
      if (value3 !== null) {
        setAdmin(value3);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  

  const handleClose1 = () => setShow1(false);

  const handleShow1 = (item) => {
    setSuppliers(item);
    setFullName1(item.name || "");
    setEmail1(item.email || "");
    setAddress1(item.address || "");
    setPhoneNo(item.phone_number || "");
    const continentId = item.continent?.id || '';
    const continentDesc = item.continent?.description || '';
    const regionId = item.region?.id || '';
    const regionDesc = item.region?.description || '';
    const provinceId = item.province?.id || '';
    const provinceDesc = item.province?.description || '';
    setSelectedContinent(continentId);
    setSelectedRegion(regionId);
    setSelectedProvince(provinceId);
  
    // Set initial single options for lazy loading
    setContinentOptions(continentId && continentDesc ? 
      [{ label: continentDesc, value: continentId }] : 
      []
    );
    setTableData4(regionId && regionDesc ? 
      [{ label: regionDesc, value: regionId }] : 
      []
    );
    setTableData5(provinceId && provinceDesc ? 
      [{ label: provinceDesc, value: provinceId }] : 
      []
    );
  
    setShow1(true);
    // No initial fetches - let onFocus handle
  };

const FetchSuppliers = async () => {
  setBenLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/users/fetch-all?page=${currentPage}`, { headers });
    const results = response.data?.data?.data;
    const resultx = response.data?.data?.total;
    setTotalEntries(resultx);
    setTableData(results);
    console.log(results);
    const total = response.data?.data?.last_page || 1;
    setTotalPages(total);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          console.log(errorMessage);
          setError(errorMessage)
        }
      }
      setTableData([]);
    }
  } finally {
    setBenLoading(false);
  }
};

const fetchSearch = async (searchTerm) => {
  setSearchLoading(true);
  try {
    let res;
    if (searchTerm.trim() === "") {
      res = tableData1;
    } else {
      const response = await axios.get(`${BASE_URL}/users/search`, {
        params: { variable: searchTerm },
        headers
      });
      res = response.data?.data;
    }
    setSearchedResult(res);
    console.log(res);

  } catch (error) {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        console.log(error);
      }
      setSearchedResult([]);
    }
  } finally {
    setSearchLoading(false);
  }
};

useEffect(() => {
  if (bearer) {
    FetchSuppliers();
  }
}, [bearer, currentPage]);

// useEffect(() => {
//   fetchSearch(searchTerm);
// }, [searchTerm]);




const handleShow = () => setShow(true);
const handleClose = () => setShow(false);

    // const handleChange = (option) => {
    //         setSelectedOption(option);
    //         console.log("Selected:", option);
    //     };
    function getLoanColors(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;

  return {
    backgroundColor: `hsl(${hue}, 70%, 90%)`, 
    color: `hsl(${hue}, 70%, 30%)`,   
  };
}


  const [rows, setRows] = useState([{ bankName: "", accName: "", accNo: "" }]);

  const addRow = () =>
    setRows([...rows, { bankName: "", accName: "", accNo: "" }]);

  const deleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

const handleUploadShow = () => setUploadShow(true);
const handleUploadClose = () => {
  setUploadShow(false);
  setFile(null);
};

const handleFileChange = (event) => {
  const file = event.target.files[0];
  setFile(file);
};

const fetchData1 = async () => {
  setIsLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/all-usertype`, { headers });
    const typeList = response.data?.data;
    console.log("lists:", typeList);
    setUserType(typeList);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Redirect to login page if unauthorized
      navigate('/login');
    } else {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
    }
  } finally {
    setIsLoading(false);
  }
};
const isAllowedUserType = (userType) => {
  const blocked = ['1', '7', '8'];
  return userType && !blocked.includes(userType);
};


const fetchContinents = async () => {
  setContLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/continents`, { headers });
    const contList = response.data?.data || [];
    const options = contList.map((item) => ({
      label: item.description,
      value: item.id,
    }));
    setContinentOptions(options);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setContinentOptions([]);
    }
  } finally {
    setContLoading(false);
  }
};

const fetchSubContinents = async (selectedContinent) => {
  setSubContLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/regions`, { headers });
    // console.log(response);
    const subCont = response.data?.data?.regions;
      const options1 = subCont.map((item) => ({
        label: item.description,
        value: item.id,
      }));
    setTableData4(options1);
    console.log(subCont, "heeeer");
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }
    setTableData4([]);
  } finally {
    setSubContLoading(false);
  }
};

// useEffect(() => {
//   if (bearer && selectedContinent) {
//     fetchSubContinents(selectedContinent);
//   }
// }, [bearer, selectedContinent]);

const fetchSubRegion = async (selectedRegion) => {
  setSubRegLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/provinces`, { headers });
    // console.log(response);
     const subCont15 = response.data?.data.provinces;
      const options25 = subCont15.map((item) => ({
        label: item.description,
        value: item.id,
      }));
    setTableData5(options25);
    // console.log(subReg, "heeeer");
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }
    setTableData5([]);
  } finally {
    setSubRegLoading(false);
  }
};

// useEffect(() => {
//   if (bearer && selectedRegion) {
//     fetchSubRegion(selectedRegion);
//   }
// }, [bearer, selectedRegion]);



useEffect(() => {
  if (bearer) {
    fetchData1();
    fetchSubContinents();
    fetchSubRegion();
    fetchContinents();
  }
}, [bearer]);


const updateBeneficiary = async () => {

  setUploadLoading(true);
  try {
    const bankAccounts = rows.map(item => item.accNo);
    const accountNames = rows.map(item => item.accName);
    const bankNames = rows.map(item => item.bankName);

    const response = await axios.post(`${BASE_URL}/beneficiaryaccounts/update`,
      {
        name: fullName1,
        email: email1,  
        phone_number: phoneNo,
        address: address1,
        bank_account: bankAccounts,
        account_name: accountNames,
        bank_name: bankNames,
        id: suppliers.id
       
      },
      { headers }
    );
    handleClose1();
    FetchSuppliers();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    })
    // .then(() => {
    //   window.location.reload();
    // });
    console.log(response.data.message)
    setUploadLoading(false);
} catch (error) {
  let errorMessage = error.response?.data?.message;
  // let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log("error", errorMessage);
          }
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: errorMessage,
          });
      }
  } finally {
    setUploadLoading(false);
  }
};

const uploadExcelHandler = async () => {
  if (!file) {
    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: 'Please select a file to upload',
    });
    return;
  }

    // Confirmation alert before upload
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to upload this file?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, upload it!",
      cancelButtonText: "No, cancel",
    });
  
    if (!result.isConfirmed) {
      handleUploadClose(); 
      return; 
    }

  setUploadLoading(true);
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(
      `${BASE_URL}/beneficiary/upload`, 
      formData, 
      { headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${bearer}`
        } });

    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message || 'File uploaded successfully',
    });
    window.location.reload();

    handleUploadClose();
    setFile("");
  } catch (error) {
    let errorMessage;

    if (error.response && error.response.data) {
      errorMessage = typeof error.response.data.message === 'object'
        ? JSON.stringify(error.response.data.message)
        : error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = 'An unexpected error occurred while uploading the file';
    }

    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setUploadLoading(false);
  }
};

const createBeneficiary = async () => {
  setLoading(true);
  try {
    const response = await axios.post(`${BASE_URL}/beneficiary/add`,
      {
        name: fullName,
        email: email,
        phone_number: phone,
        address: address,
        bank_name: bankName,
        account_name: accName,
        account_number: accNo
      },
      { headers }
    );
    console.log(response.data.message);
    setFullName('');
    setEmail('');
    setPhone('');
    setAddress('');
    setBankName('');
    setAccName('');
    setAccNo('');
    FetchSuppliers();
    handleClose();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    console.log(response.data.message);

  } catch (error) {
    let errorMessage;

    // Attempt to extract the error message
    if (error.response && error.response.data) {
      // If message is an object, attempt to stringify it
      if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      } else {
        errorMessage = error.response.data.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = "An unexpected error occurred";
    }

    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setLoading(false);
  }
};

 //delete function
 const handleTrashClick = async (id) => {
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: 'You are about to delete this user.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, cancel',
  });

  if (!confirmed.isConfirmed) {
    return; // User canceled, do nothing
  }
  setUploadLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/users/delete?id=${id}`, { headers });
    FetchSuppliers();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
   
    setUploadLoading(false);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
      // toast.error(errorMessage)
      console.log(errorMessage);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorMessage,
      });
    }
  }
  finally {
    setUploadLoading(false); // always stop uploading, success or fail
  }
};

const fetchAreas = async () => {
  setIsLoading(true);
  try {
    const response = await axios.get(
      `${BASE_URL1}/provinces/getaparishprovince`,
      {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
      }
    );

    const results = response.data?.data;
    console.log(results);
    setTableData(results);

    // const resultx = response.data?.data?.parishes?.total;
    // setTotalEntries(resultx);

    // const total = response.data?.data?.parishes?.last_page || 1;
    // setTotalPages(total);

    // Transform the API response to match the expected { value, label } format
    const formattedOptions =
      results?.map((item) => ({
        value: item.id, // Adjust based on API response structure
        label: item.description, // Adjust based on API response structure
      })) || [];

    setOptions(formattedOptions);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Redirect to login page if unauthorized
      // navigate('/login');
    } else {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setTableData([]);
    }
    console.log(error);
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  if (TOKEN) {
    fetchAreas();
  }
}, [TOKEN]);

const handleContinentChange = (event) => {
  setSelectedContinent(event.target.value);
  setSelectedRegion('');
  setSelectedProvince('');
};

const handleRegionChange = (event) => {
  setSelectedRegion(event.target.value);
};

const handleProvinceChange = (event) => {
  setSelectedProvince(event.target.value);
};

const createUser = async () => {
  if (!selectedRole) {
    // toast.error("Please select a role.");
    return; // Stop submission if role is not selected
  }

  setCreateLoading(true);
  try {
    const payload = {
      name: fullName,
      email: email,
      phone_number: phone,
      type: selectedRole,
      // parishId
    };

    const response = await axios.post(
      `${BASE_URL1}/user/create-province-users`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
      }
    );
    console.log(response);

    // navigate(-1);
    setFullName("");
    setPhone("");
    setEmail("");
    // setSelectType("");
    setSelectedRole("");
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    console.log(response.data);
  } catch (error) {
    let errorMessage = "An error occurred. Please try again.";
    if (
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      if (typeof error.response.data.message === "string") {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join("; ");
      } else if (typeof error.response.data.message === "object") {
        errorMessage = JSON.stringify(error.response.data.message);
      }
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorMessage,
      });
      // toast.error(JSON.stringify(error.response.data.message));
    }
    console.log(error);
  } finally {
    setCreateLoading(false);
  }
};


const handleSelectChange = (event) => {
  setSelectedRole(event.target.value); // Update state with selected value
};

const startIndexx = (currentPage - 1) * entriesPerPage + 1;
const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);

const filteredData = tableData.filter(item => {
  const term = searchTerm.toLowerCase();
  return (
    (item?.name?.toLowerCase().includes(term)) ||
    (item?.email?.toLowerCase().includes(term)) ||
    (item?.phone_number?.toLowerCase().includes(term)) ||
    (item?.type_name?.toLowerCase().includes(term)) ||
    (item?.province?.description?.toLowerCase().includes(term))
  );
});

const displayedData = searchTerm.trim() ? searchedResult : filteredData;
const formattedTotalEntries = totalEntries.toLocaleString();

const handlePrevPage = () => {
  setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
};

const handleNextPage = () => {
  setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
};


const handleTypeChange = (e) => setSelectType(e.target.value);




        
  return (
    <div >
        <HeaderNav />
      
    
<Modal show={show1} onHide={handleClose1} size="lg" animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>Update User</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
      <Row>
        <Col>
        <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Name</Form.Label>
        <Form.Control
          type="text"
          placeholder="Name"
          value={fullName1}
          onChange={(e) => setFullName1(e.target.value)}
        />
        </Col>

        <Col>
        <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Email</Form.Label>
        <Form.Control
          type="text"
          placeholder="Email"
          value={email1}
          onChange={(e) => setEmail1(e.target.value)}
        />
        </Col>
      </Row>

      <Row>
        <Col>
        <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Phone Number</Form.Label>
        <Form.Control
          type="text"
          placeholder="Phone Number"
          value={phoneNo}
          onChange={(e) => setPhoneNo(e.target.value)}
        />
        </Col>

        {admin === "Super Admin" && (
                        <>
                          <Col md={6}>
                            <Form.Group controlId="formSelectType">
                              <Form.Label>Select Type</Form.Label>
                              <Form.Select
                                value={selectType}
                                onChange={handleTypeChange}
                              >
                                <option value="">Select Type</option>
                                {userType.map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.type}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                        </>
                      )}
      </Row>
        
      </Form.Group>
      
      {isAllowedUserType(userType) && (
                      <>

                        <Row className="mb-3">
                        <Col md={6}>
  <Form.Group controlId="formContinent">
    <Form.Label>Select Continent</Form.Label>
    <Form.Select
      className="form-control"
      value={selectedContinent}
      onChange={handleContinentChange}
      onFocus={() => {
        if (continentOptions.length <= 1 && !contLoading) {
          fetchContinents();
        }
      }}
    >
      <option value="" disabled>Select Continent</option>
      {contLoading ? (
        <option disabled>Loading...</option>
      ) : continentOptions.length === 0 ? (
        <option disabled>No continents available</option>
      ) : (
        continentOptions.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))
      )}
    </Form.Select>
  </Form.Group>
</Col>


<Col md={6}>
    <Form.Group controlId="formRegion">
      <Form.Label>Select Region</Form.Label>
      <Form.Select
        className="form-control"
        value={selectedRegion}
        onChange={handleRegionChange}
        onFocus={() => {
          if (selectedContinent && tableData4.length <= 1 && !subContloading) {
            fetchSubContinents(selectedContinent);
          }
        }}
      >
        <option value="" disabled>Select Region</option>
        {subContloading ? (
          <option disabled>Loading...</option>
        ) : tableData4.length === 0 ? (
          <option disabled>No regions available</option>
        ) : (
          tableData4.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))
        )}
      </Form.Select>
    </Form.Group>
  </Col>

                        </Row>


                        <Row className="mb-3">
                        <Col md={6}>
    <Form.Group controlId="formProvince">
      <Form.Label>Select Province</Form.Label>
      <Form.Select
        className="form-control"
        value={selectedProvince}
        onChange={handleProvinceChange}
        onFocus={() => {
          if (selectedRegion && tableData5.length <= 1 && !subRegloading) {
            fetchSubRegion(selectedRegion);
          }
        }}
      >
        <option value="" disabled>Select Province</option>
        {subRegloading ? (
          <option disabled>Loading...</option>
        ) : tableData5.length === 0 ? (
          <option disabled>No provinces available</option>
        ) : (
          tableData5.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))
        )}
      </Form.Select>
    </Form.Group>
  </Col>
                        </Row>
                      </>
                    )}

 
    </Form>
  </Modal.Body>
  <Modal.Footer style={{marginRight: "14px"}}>
    <Button variant="danger" onClick={handleClose1}>
      Go back
    </Button>
    <Button className={classes.customButton} onClick={updateBeneficiary}>
     Update User
    </Button>

  </Modal.Footer>
</Modal>

<Modal show={uploadShow} onHide={handleUploadClose} animation={false}>
              <Modal.Header closeButton>
                <Modal.Title>Upload Excel File</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{padding: 0}}>
                <Form style={{ marginTop: 5 }}>
               
                  <Form.Group style={{padding: 10,}}>
                  {/* <button  className={classes.customButton1} >
                  <a href="https://account-api.patna.ng/api/v1/download_suppliers_template" download>
                  <img src={download} alt="download" /> Download Template
                    </a>
                </button> */}
                </Form.Group>
                  {/* <hr className={classes.downline} /> */}


                  <Form.Group style={{padding: 10}} className="mb-3" controlId="exampleForm.ControlInput2">
                    <Form.Label>Select Excel File</Form.Label>
                    <Form.Control
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={handleFileChange}
                    />
                    <div style={{ marginTop: 10 }} />
                  </Form.Group>

                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="danger" onClick={handleUploadClose}>
                  Go back
                </Button>
                <Button  className={classes.customButton}  onClick={uploadExcelHandler}>
                  Upload File
                </Button>
              
              </Modal.Footer>
            </Modal>
            {uploadLoading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}

            <Modal show={show} size="lg" onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Create User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form style={{ marginTop: 20 }}>
            <Row>
              <Col>
              <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </Col>
              <Col>
              {/* <div style={{ marginTop: 10 }} /> */}
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Phone Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Col>
            </Row>

            <Row>
              <Col>
              <div style={{ marginTop: 10 }} />
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Col>
              <Col >
              <div style={{ marginTop: 10 }} />
                        <Form.Label>Role</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          required
                          value={selectedRole} // Ensure selectedRole is bound to Form.Select
                          onChange={handleSelectChange} // Ensure onChange is correctly set to handle value changes
                        >
                          <option disabled value="">
                            Select Role
                          </option>{" "}
                          {/* Prevent empty selection */}
                          <option value="Checker">Checker</option>{" "}
                          {/* Default role */}
                        </Form.Select>
                      </Col>
            </Row>
            <Row className="mb-3">
                      <Col md={6}>
                      <div style={{ marginTop: 10 }} />
                        <Form.Label>Parish</Form.Label>
                        <Select options={options} />
                      </Col>
                    </Row>
              {/* <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
               
                
                
                <div style={{ marginTop: 10 }} />
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Bank Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Supplier's Bank Name"
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Account Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Supplier's Account Name"
                  value={accName}
                  onChange={(e) => setAccName(e.target.value)}
                />
                <div style={{ marginTop: 10 }} />
                <Form.Label>Account Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Supplier's Account Number"
                  value={accNo}
                  onChange={(e) => setAccNo(e.target.value)}
                />
              </Form.Group> */}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={handleClose}>
              Cancel
            </Button>
            <Button className={classes.customButton} onClick={createUser}>
            {createLoading ? (
                    <>
                      <Spinner size="sm" />
                      <span style={{ marginLeft: "5px" }}>
                        Creating user, Please wait...
                      </span>
                    </>
                  ) : (
                    "Add User"
                  )}
              
            </Button>
          </Modal.Footer>
        </Modal>
        {loading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}


        <div className={classes.topContainer}>
          {/* <div className={classes.topNavBars}>
            <Button className={classes.buttonsNav}>Remitances</Button>
            <Button className={classes.buttonsNav}>Petty Cash</Button>
            <Button className={classes.buttonsNav}>Supplier's Payment</Button>
            <Button className={classes.buttonsNav}>Customer's Leger</Button>
          </div> */}
          <div style={{}} className={classes.headtxt}>
            <h3 className={classes.topText}>Manage User</h3>
            <p className={classes.prgText}>Add, View, Edit and Delete Users.</p>
            </div>

            <div className={classes.subContainer}>            
            <div className={classes.laysbtns}>
                            <button className={classes.loanBtn} 
                            onClick={handleShow}
                            >
                              <img src={plus} alt="plus" /> 
                              Add User
                            </button>
                            {/* <button className={classes.loanBtn} 
                          onClick={handleUploadShow}
                          >
                            Upload Excel
                          </button> */}

                            {/* <button  className={classes.customButton1} >
                            <a href="https://account-api.patna.ng/api/v1/download_suppliers_template" download>
                            <img src={download} alt="download" /> Download Template
                              </a>
                          </button>  */}
                          </div>

                          <div className={classes.statCount}>
                              <div className={classes.statConn}>
                              <p className={classes.txtHd}>Total Users</p>
                              <p className={classes.txtHds}>{formattedTotalEntries}</p>
                              </div>
                            </div>

                         <div className={classes.searchInputWrapper}>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className={classes.searchInput}
                                    placeholder="Search user..."
                                />
                                <Search className={classes.searchIcon} size={16} />
                            </div>

            </div>
            
            <div className={classes.tableContainer}>
            
          <table className={classes.tableTable}>
  <thead className={classes.tableHeader}>
                             <tr>
                              {/* <th>S/N</th> */}
                              <th>#</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Phone Number</th>
                              <th>User Type</th>
                              <th>Station</th>
                              <th>Actions</th>
                            </tr>
  </thead>
  <tbody>

  { benLoading ? (
    searchTerm ? (
      <tr>
        <td colSpan={5} style={{ textAlign: "center" }}>
          Fetching Users...
        </td>
      </tr>
    ) : (
      Array(5).fill().map((_, idx) => (
        <tr key={idx}>
          {Array(7).fill().map((_, i) => (
            <td key={i}>
              <Skeleton height={20} style={{ marginBottom: 10 }} />
            </td>
          ))}
        </tr>
      ))
    )
  ) : (
    displayedData.map((item, index) => (

      <tr key={index}>
      <td className={classes.textby}>{index + 1}</td>
      <td className={classes.textby}>{item.name}</td>
      <td className={classes.textby}>{item.email}</td>
      <td className={classes.textby}>{item.phone_number}</td>
      <td className={classes.textby} style={{whiteSpace: "wrap"}}>{item.type_name}</td>
      <td className={classes.textby} style={{whiteSpace: "wrap"}}>{item.province?.description}</td>
      <td style={{display: "flex", gap: "10px"}}>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="button-tooltip">Click to view user</Tooltip>}
        >
          <button 
          style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
          onClick={() => handleShow1(item)} >
          <img src={EyeIcon} />
          </button>
        </OverlayTrigger>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="button-tooltip">Click to delete user's row</Tooltip>}
        >
          <button 
          style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
           onClick={() => handleTrashClick(item.id)}>

          <img src={DeleteIcon} />
          </button>
        </OverlayTrigger>
      </td>
    </tr>
    ))
  )
}
  </tbody>
  {!benLoading && searchTerm && displayedData.length === 0 && (
  <tbody>
    <tr>
      <td colSpan={5} style={{ textAlign: "center" }}>
        No User found
      </td>
    </tr>
  </tbody>
)}

</table>

{!benLoading && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${currentPage} - ${totalPages} pages`} of {formattedTotalEntries} entries</p>
            </div>
          )}



            </div>
        </div>
    </div>
  )
}

export default FixedAssetAdminUser;